/**
 * Credits: https://www.emgoto.com/react-table-of-contents/
 */

import { useEffect, useRef, useState } from "react";

export const useActiveHeading = () => {
    const [activeId, setActiveId] = useState<string | null>(null);

    const headingElementsRef = useRef<Record<string, IntersectionObserverEntry>>({});

    useEffect(() => {
        const observer = new IntersectionObserver(
            headings => {
                headingElementsRef.current = headings.reduce((map, headingElement) => {
                    map[headingElement.target.id] = headingElement;
                    return map;
                }, headingElementsRef.current);

                const visibleHeadings: IntersectionObserverEntry[] = [];
                Object.keys(headingElementsRef.current).forEach(key => {
                    const headingElement = headingElementsRef.current[key];
                    if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
                });

                const getIndexFromId = id => headingElements.findIndex(heading => heading.id === id);

                if (visibleHeadings.length === 1) {
                    setActiveId(visibleHeadings[0].target.id);
                } else if (visibleHeadings.length > 1) {
                    const sortedVisibleHeadings = visibleHeadings.sort(
                        (a, b) => getIndexFromId(a.target.id) - getIndexFromId(b.target.id)
                    );

                    setActiveId(sortedVisibleHeadings[0].target.id);
                }
            },
            {
                // 60px is almost the navbar, we can't use var(--navbar-height) for rootMargin
                rootMargin: "-80px 0px -40% 0px",
            }
        );

        const headingElements = Array.from(document.querySelectorAll("h1, h2, h3, h4, h5, h6"));

        headingElements.forEach(element => observer.observe(element));

        return () => observer.disconnect();
    }, []);

    return activeId;
};
